import { ReadDocumentDto } from '@inosio/payments-sdk';
import { createSlice } from '@reduxjs/toolkit';
import { ErrorType, RootState } from '../../../app/store';

type DocumentState = {
  uploadDocumentResponse: ReadDocumentDto[]; //uploaded files
  isUploadingDocuments: boolean;
  isUploadingDocumentsSuccess: boolean;
  isUploadingDocumentsFailed: boolean;
  isDeletingDocument: boolean;
  isDeletingDocumentSuccess: boolean;
  isDeletingDocumentFailed: boolean;
  documentErrorMessage: ErrorType;
  // fetchDocumentResponse: ReadDocumentDto[];
  // isFetchingDocuments: boolean;
  // isFetchingDocumentsSuccess: boolean;
  // isFetchingDocumentsFailed: boolean;
  // fetchDocumentError: ErrorType;
};

const getInitialState = () => {
  return {
    uploadDocumentResponse: [],
    isUploadingDocuments: false,
    isUploadingDocumentsSuccess: false,
    isUploadingDocumentsFailed: false,
    isDeletingDocument: false,
    isDeletingDocumentSuccess: false,
    isDeletingDocumentFailed: false,
    documentErrorMessage: {} as ErrorType,
    // fetchDocumentResponse: [],
    // isFetchingDocuments: false,
    // isFetchingDocumentsSuccess: false,
    // isFetchingDocumentsFailed: false,
    // fetchDocumentError: {} as ErrorType,
  } as DocumentState;
};

const documentSlice = createSlice({
  name: 'document',
  initialState: getInitialState(),
  reducers: {
    uploadDocuments(state, action) {
      state.isUploadingDocumentsSuccess = false;
      state.isUploadingDocumentsFailed = false;
      state.isUploadingDocuments = true;
    },
    handleUploadDocumentsSuccess(state, action) {
      const response = {
        isUploadingDocumentsSuccess: true,
        isUploadingDocuments: false,
        isUploadingDocumentsFailed: false,
        uploadDocumentResponse: action.payload,
      };
      return { ...state, ...response };
    },
    handleUploadDocumentsFailed(state, action) {
      state.isUploadingDocumentsSuccess = false;
      state.isUploadingDocuments = false;
      state.isUploadingDocumentsFailed = true;
      state.documentErrorMessage = action.payload;
    },
    deleteDocument(state, action) {
      state.isDeletingDocumentSuccess = false;
      state.isDeletingDocumentFailed = false;
      state.isDeletingDocument = true;
    },
    handleDeleteDocumentSuccess(state) {
      const response = {
        isDeletingDocumentSuccess: true,
        isDeletingDocument: false,
        isDeletingDocumentFailed: false,
      };
      return { ...state, ...response };
    },
    handleDeleteDocumentFailed(state, action) {
      state.isDeletingDocumentSuccess = false;
      state.isDeletingDocument = false;
      state.isDeletingDocumentFailed = true;
      state.documentErrorMessage = action.payload;
    },
    resetDocumentsState(state) {
      return getInitialState();
    },
    // getDocuments(state, action) {
    //   state.isFetchingDocuments = true;
    //   state.isFetchingDocumentsFailed = false;
    //   state.isFetchingDocumentsSuccess = false;
    //   state.fetchDocumentResponse = [];
    //   state.fetchDocumentError = {} as ErrorType;
    // },
    // setDocuments(state, action) {
    //   state.isFetchingDocuments = false;
    //   state.isFetchingDocumentsFailed = false;
    //   state.isFetchingDocumentsSuccess = true;
    //   state.fetchDocumentResponse = action.payload;
    //   state.fetchDocumentError = {} as ErrorType;
    // },
    // getDocumentsError(state, action) {
    //   state.isFetchingDocuments = false;
    //   state.isFetchingDocumentsFailed = true;
    //   state.isFetchingDocumentsSuccess = false;
    //   state.fetchDocumentResponse = [];
    //   state.fetchDocumentError = action.payload;
    // },
  },
});
export const { uploadDocuments, handleUploadDocumentsSuccess, handleUploadDocumentsFailed, deleteDocument, handleDeleteDocumentSuccess, handleDeleteDocumentFailed, resetDocumentsState } = documentSlice.actions;

export default documentSlice.reducer;
export const selectDocumentState = (state: RootState) => state.documentState;
